import { Link, useLocation } from 'react-router-dom';
import { Linkedin } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const SharedFooter = () => {
  const { t } = useTranslation();

  return (
    <footer className="shared-footer" data-testid="shared-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-20 md:py-24">
        <div className="mb-16">
          <h2 className="text-[8vw] md:text-[5vw] font-extrabold tracking-tighter leading-none text-white/10" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>DURABLE DESIGNS</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div>
            <span className="text-[13px] font-semibold tracking-[0.12em] uppercase text-white block mb-4" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>{t('footer.brand')}</span>
            <p className="text-sm leading-relaxed text-neutral-500 mb-4" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>{t('footer.desc')}</p>
            <p className="text-xs leading-relaxed text-neutral-600 mb-1">{t('footer.incorporation')}</p>
            {t('footer.incorporation_detail') && (
              <p className="text-xs leading-relaxed text-neutral-600 mb-4">{t('footer.incorporation_detail')}</p>
            )}
            <p className="text-xs text-neutral-600" data-testid="footer-copyright">&copy; {new Date().getFullYear()} Concrete Control LLC. Durable Designs is a trading name of Concrete Control LLC.</p>
          </div>
          <div>
            <h4 className="text-[10px] font-semibold tracking-[0.15em] uppercase text-neutral-500 mb-4" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>{t('footer.engineering')}</h4>
            <ul className="space-y-2.5">
              {[
                { name: t('nav.services'), path: '/engineering/services' },
                { name: t('nav.projects'), path: '/engineering/projects' },
                { name: t('nav.apps'), path: '/engineering/apps' },
                { name: t('nav.knowledge'), path: '/engineering/knowledge' },
                { name: t('nav.people'), path: '/engineering/people' },
                { name: t('nav.contact'), path: '/engineering/contact' },
              ].map((link) => (
                <li key={link.path}><Link to={link.path} className="text-sm text-neutral-500 hover:text-white transition-colors">{link.name}</Link></li>
              ))}
            </ul>
          </div>
          {/* v26.12 — Architecture column removed (practice discontinued). */}
          <div>
            <h4 className="text-[10px] font-semibold tracking-[0.15em] uppercase text-neutral-500 mb-4" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>{t('footer.legal_connect')}</h4>
            <ul className="space-y-2.5 mb-6">
              <li><Link to="/privacy-policy" className="text-sm text-neutral-500 hover:text-white transition-colors" data-testid="footer-privacy">{t('footer.privacy')}</Link></li>
              <li><Link to="/legal" className="text-sm text-neutral-500 hover:text-white transition-colors" data-testid="footer-legal">{t('footer.legal')}</Link></li>
            </ul>
            <div className="space-y-2">
              <a href={typeof window !== 'undefined' ? window.location.origin : 'https://durabledesigns.co.uk'} target="_blank" rel="noopener noreferrer" className="block text-sm text-neutral-500 hover:text-white transition-colors" data-testid="footer-website">{typeof window !== 'undefined' ? window.location.hostname : 'durabledesigns.co.uk'}</a>
              <a href="https://www.linkedin.com/company/durabledesignsltd/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm text-neutral-500 hover:text-white transition-colors" data-testid="footer-linkedin"><Linkedin className="w-4 h-4" /> LinkedIn</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
